const IOS_MIN_VER = 11.3;
const IOS_SAFARI_MIN_VER = 11.3;
const ANDROID_MIN_VER = 5;
const ANDROID_CHROME_MIN_VER = 78;

import MobileDetect from "mobile-detect";
const md = new MobileDetect(window.navigator.userAgent);
const phone = md.phone();
console.log("md.phone()", phone);
let isTablet = md.tablet();
console.log("md.tablet()", isTablet);
const os = md.os();
console.log("md.os()", os);
console.log("md.version()", md.version(os));
console.log("md", md);
let isOS = os == "iOS" || os == "iPadOS";

// iPadOS13がUAに含まれなくなり、検出不可能なのでmacは通す
//[iOS13とiPadOSに備える（フロントエンド） - Qiita](https://qiita.com/zprodev/items/7e133e801e88ae966dc5)
if (!phone && !isTablet && navigator.platform === "MacIntel" && document.ontouchstart !== undefined) {
  isTablet = true;
  isOS = true;
}

const isAndroid = os == "AndroidOS";

let version = 0;
let browserVersion = 0;
if (isOS) {
  version = md.version("iOS");
  browserVersion = md.version("Safari");
} else {
  if (isAndroid) {
    version = md.version("Android");
    browserVersion = md.version("Chrome");
  }
}
console.log("browserVersion", browserVersion);


// TODO 2025-03-26 iPadの制限を外す
isTablet = true;
const checkDevice = () => {
  // TODO 2025-03-26 iPadの制限を外す
  return true;
  if (!phone && !isTablet) return false;
  if (isOS) {
    return version >= IOS_MIN_VER && browserVersion >= IOS_SAFARI_MIN_VER;
  } else if (isAndroid) {
    return (
      version >= ANDROID_MIN_VER && browserVersion >= ANDROID_CHROME_MIN_VER
    );
  }
  return false;
};

const state = {
  phone: phone,
  tablet: isTablet,
  pc: !phone && !isTablet,
  os: os,
  version: version,
  browserVersion: browserVersion,
  isOKDevice: checkDevice()
};

export const device = {
  namespaced: true,

  state: state,
  getters: {},
  mutations: {},
  actions: {}
};
